import { render, staticRenderFns } from "./ImageSideCard.vue?vue&type=template&id=13bba5d6"
import script from "./ImageSideCard.vue?vue&type=script&lang=js"
export * from "./ImageSideCard.vue?vue&type=script&lang=js"
import style0 from "./ImageSideCard.vue?vue&type=style&index=0&id=13bba5d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports